import useAuth from "hooks/useAuth"
import { isArray, isString } from "lodash-es"
import { useMemo } from "react"
import { VesaRouteType } from "routes"

type Options = {
  showHidden?: boolean
  routes?: VesaRouteType[]
  scanDeep?: boolean
}
export function useAuthenticatedRoutes(options?: Options) {
  const showHidden = options?.showHidden
  const routes = options?.routes
  const scanDeep = options?.scanDeep || true
  const { permissions, user, token } = useAuth()
  const isAdmin = user?.isSuperadmin
  const userId = user?.id
  return useMemo(() => {
    if (token && !userId) return null
    // Checks whetever the given route is valid or not based on the below conditions
    // 1. is route production ready?
    // 2. is the route authorized?
    // 3. is the authenticated user an admin?
    // 4. does the user have permission?
    function checkValidity(route: VesaRouteType) {
      // we consider NODE_ENV and not any custom env variable to ensure that the routes stay
      // consistent on staging and production avoiding any human errors
      if (
        process.env.REACT_APP_ENV === "production" &&
        route.production === false
      )
        return false
      if (!route.permission) return true
      if (isAdmin) return true
      if (isString(route.permission)) {
        const per: any = route.permission
        return permissions?.find(p => p?.match(per))
      } else if (isArray(route.permission)) {
        return route.permission.some(rp =>
          permissions?.find(p => p?.includes(rp))
        )
      }
      return true
    }
    return routes?.reduce<VesaRouteType[]>(function filter(prev, route): any {
      const isValid = checkValidity(route)
      const show = route.hide ? showHidden : true
      if (isValid && show) {
        if (route.children && route.children.length > 0 && scanDeep) {
          return prev.concat({
            ...route,
            children: route.children.reduce(filter, []),
          })
        } else {
          return prev.concat(route)
        }
      }
      return prev
    }, [])
  }, [isAdmin, permissions, showHidden, token, userId, routes, scanDeep])
}
